module.exports = __webpack_public_path__ + "img/12_Tourismus_iPad_L.0f6760ac.jpg";